import { makeObservable, action, observable, runInAction } from 'mobx';
import { DataResponse, PagedResponse, UserVoucher, UserVoucherService } from 'us-web-services';
import { UserStore } from '../UserStore';

export class CreditsStore {
  #userId?: number;
  activeCredits?: PagedResponse<UserVoucher>;
  inactiveCredits?: PagedResponse<UserVoucher>;
  loadError = false;

  constructor(user: UserStore) {
    this.#userId = user.user.id;

    makeObservable(this, {
      refreshUserVouchers: action,
      activeCredits: observable,
      inactiveCredits: observable,
      loadError: observable,
    });

    this.refreshUserVouchers();
  }

  refreshUserVouchers = async (): Promise<void> => {
    try {
      const activeResp = await this.#getActiveCredits();
      const inactiveResp = await this.#getInactiveCredits();

      runInAction(() => {
        this.activeCredits = activeResp;
        this.inactiveCredits = inactiveResp;
        this.loadError = false;
      });
    } catch {
      runInAction(() => {
        this.loadError = true;
      });
    }
  };

  redeemVoucher = async (voucher: string): Promise<DataResponse<UserVoucher>> => {
    const data = {
      userId: this.#userId,
      voucher: {
        code: voucher,
      },
    };
    const response = await UserVoucherService.create(data);
    this.refreshUserVouchers();

    return response;
  };

  #getActiveCredits = async (): Promise<PagedResponse<UserVoucher>>  => {
    const config = {
      params: {
        userId: this.#userId,
        active: true,
      }
    }
    return UserVoucherService.getByFilter(config);
  }

  #getInactiveCredits = async (): Promise<PagedResponse<UserVoucher>>  => {
    const config = {
      params: {
        userId: this.#userId,
        active: false,
      }
    }
    return UserVoucherService.getByFilter(config);
  }
}
